<template>
  <div class="container my-5">
    <h3>{{ t('sales_chart.title') }}</h3>

    <div class="d-flex flex-wrap mb-3">
      <div
        class="border rounded px-3 py-2 me-3 mb-3 bg-light shadow-sm"
        v-for="district in districts"
        :key="district.value"
      >
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            :id="district.value"
            :value="district.value"
            v-model="selectedDistricts"
          />
          <label class="form-check-label" :for="district.value">
            {{ t(`sales_chart.districts.${district.value}`) }}
          </label>
        </div>
      </div>
    </div>

    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import axios from 'axios'
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  Tooltip,
  Legend
} from 'chart.js'

const { t } = useI18n()

Chart.register(LineController, LineElement, PointElement, LinearScale, Title, CategoryScale, Tooltip, Legend)

const chartCanvas = ref(null)
let chartInstance = null

const districts = [
  { value: 'alanya' },
  { value: 'konyaalti' },
  { value: 'kemer' },
  { value: 'kepez' },
  { value: 'dosemealti' },
  { value: 'finike' }
]

const selectedDistricts = ref(['alanya'])
const colors = ['#007bff', '#28a745', '#dc3545', '#ffc107', '#6610f2', '#17a2b8']

const fetchData = async () => {
  try {
    const requests = selectedDistricts.value.map(district =>
      axios.get(`/api/v1/statistics/sales/${district}`)
    )
    const responses = await Promise.all(requests)

    const datasets = responses.map((response, index) => {
      const data = response.data
      return {
        label: t(`sales_chart.districts.${selectedDistricts.value[index]}`),
        data: data.map(entry => entry.sales),
        borderWidth: 2,
        borderColor: colors[index % colors.length],
        pointRadius: 2,
        fill: false
      }
    })

    const labels = responses[0]?.data.map(entry => entry.date) || []

    if (chartInstance) {
      chartInstance.data.labels = labels
      chartInstance.data.datasets = datasets
      chartInstance.update()
    } else {
      chartInstance = new Chart(chartCanvas.value, {
        type: 'line',
        data: {
          labels,
          datasets
        },
        options: {
          responsive: true,
          plugins: {
            title: { display: false },
            legend: { display: true }
          },
          scales: {
            x: { title: { display: true, text: t('sales_chart.x_axis') } },
            y: { title: { display: true, text: t('sales_chart.y_axis') } }
          }
        }
      })
    }
  } catch (error) {
    console.error('Ошибка при загрузке данных:', error)
  }
}

onMounted(fetchData)
watch(selectedDistricts, fetchData)
</script>
